import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./mobile-fixes.css";

import { AuthProvider } from "./context/AuthContext";

import SeasonList from "./components/SeasonList";
import TeamList from "./components/TeamList";
import PlayerList from "./components/PlayerList";
import ScheduleManagement from "./components/ScheduleManagement";
import MatchDetail from "./components/MatchDetail";
import RosterManagement from "./components/RosterManagement";
import LeagueTableManagement from "./components/LeagueTableManagement";
import TournamentRegistration from "./components/TournamentRegistration";
import TournamentManagement from "./components/TournamentManagement";
import IndividualMatchManagement from "./components/IndividualMatchManagement";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import UserManagement from "./components/UserManagement";
import TeamLevelList from "./components/TeamLevelList";
import NewsManagement from "./components/NewsManagement";
import NewsForm from "./components/NewsForm";
import Dashboard from "./components/Dashboard";
import InstallPWA from "./components/InstallPWA";
import DrawManagement from "./components/DrawManagement";
import ChangePassword from "./components/ChangePassword";
import AdManagement from "./components/AdManagement";
import NotificationInbox from "./components/NotificationInbox";
import TeamTournamentDetail from "./components/TeamTournamentDetail";

function App() {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route
            path="/login"
            element={
              <main className="public-route-shell">
                <Login />
              </main>
            }
          />
          <Route
            path="/register-tournament/:uuid"
            element={
              <main className="public-route-shell">
                <TournamentRegistration />
              </main>
            }
          />

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/seasons" element={<SeasonList />} />
            <Route path="/teams" element={<TeamList />} />
            <Route path="/players" element={<PlayerList />} />
            <Route path="/schedules" element={<ScheduleManagement />} />
            <Route path="/draw" element={<DrawManagement />} />
            <Route path="/schedules/:scheduleId" element={<MatchDetail />} />
            <Route path="/rosters" element={<RosterManagement />} />
            <Route path="/tables" element={<LeagueTableManagement />} />
            <Route path="/tournaments" element={<TournamentManagement />} />
            <Route
              path="/tournaments/:uuid/teams"
              element={<TeamTournamentDetail />}
            />
            <Route
              path="/individual-matches"
              element={<IndividualMatchManagement />}
            />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/news" element={<NewsManagement />} />
            <Route path="/news/new" element={<NewsForm />} />
            <Route path="/news/:id/edit" element={<NewsForm />} />
            <Route path="/ads" element={<AdManagement />} />
            <Route path="/levels" element={<TeamLevelList />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/notifications" element={<NotificationInbox />} />
          </Route>
        </Routes>
        <InstallPWA />
      </Router>
    </AuthProvider>
  );
}

export default App;
